import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const API_BASE = "https://newerp.awasthivitality.com/api";

const getSessionToken = () =>
  (localStorage.getItem("session_token") || "").trim();

const appendToken = (url) => {
  const token = getSessionToken();
  if (!token) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.searchParams.has("token")) {
      parsed.searchParams.append("token", token);
    }
    return parsed.toString();
  } catch {
    return url;
  }
};

const getAuthHeaders = () => {
  const token = getSessionToken();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers["X-Session-Token"] = token;
  }
  return headers;
};

const LocalNote = () => {
  const navigate = useNavigate();
  const { patient_id } = useParams(); // 🔥 Extract patient_id from URL (matches route :patient_id)
  const [formData, setFormData] = useState({
    // Keep date initialization for pdn_date
    date: new Date().toISOString().slice(0, 10),
    pdn_time: "", // New time field
    comments: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setMessageType("");

    // if (!formData.comments?.trim()) {
    //   setMessage("❌ Comments are required.");
    //   setMessageType("error");
    //   setLoading(false);
    //   return;
    // }

    if (!patient_id) {
      setMessage("❌ Patient ID is required.");
      setMessageType("error");
      setLoading(false);
      return;
    }

    try {

      const apiUrl = `${API_BASE}/patient/${patient_id}/notes/add`;

      // 🔥 ONLY INCLUDE date, pdn_time, and comments for the request body
      // Backend automatically saves current user name from token
      const requestBody = {
        pdn_date: formData.date,
        pdn_time: formData.pdn_time, // Include time
        pdn_message: formData.comments,
      };

      const response = await fetch(appendToken(apiUrl), {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();

      if (result.success) {
        setMessage("✅ " + result.message);
        setMessageType("success");
        setTimeout(() => navigate("/LocalNotepad"), 1000);
      } else {
        setMessage("❌ Failed: " + (result.message || "Unable to save note"));
        setMessageType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setMessage(`❌ ${error.message || "Something went wrong, please try again."}`);
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass-container">
      <div className="glass-card">
        <h2 className="glass-header">+ Add Today’s Local Notes</h2>
        <form className="glass-form" onSubmit={handleSave}>
          {[
            // 🔥 Updated fields array
            { name: "date", placeholder: "Date", type: "date", required: true },
            { name: "pdn_time", placeholder: "Time", type: "time", required: true },
            { name: "comments", placeholder: "Comments", type: "text" },
          ].map((field) => (
            <input
              key={field.name}
              type={field.type}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              placeholder={field.placeholder}
              required={field.required}
              className="glass-input"
            />
          ))}

          <div className="glass-actions">
            <button
              type="submit"
              className="glass-save-btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              className="glass-clear-btn"
              onClick={() => navigate("/LocalNotepad")}
              disabled={loading}
            >
              Cancel
            </button>
          </div>

          {message && (
            <div className={`glass-message ${messageType}`}>{message}</div>
          )}
        </form>
      </div>

      <style jsx>{`
        body, html {
          background: linear-gradient(135deg, #ece9e6, #ffffff);
          height: 100%;
          margin: 0;
        }

    .glass-container {
  display: flex;
  justify-content: center;
  align-items: flex-start; /* stick to top */
  padding-top: 20px;       /* 20px space from top */
  min-height: 100vh;
}


        .glass-card {
          background: rgba(255, 255, 255, 0.25);
          backdrop-filter: blur(15px);
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          padding: 25px 30px;
          max-width: 450px;
          width: 100%;
          text-align: center;
          transition: all 0.3s ease;
        }

        .glass-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
        }

        .glass-header {
          font-size: 1.8rem;
          color: #333;
          margin-bottom: 20px;
        }

        .glass-form {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .glass-input {
          padding: 10px 12px;
          border-radius: 12px;
          border: 1px solid rgba(200, 200, 200, 0.5);
          background: rgba(255, 255, 255, 0.8);
          font-size: 0.95rem;
          transition: all 0.3s ease;
        }

        .glass-input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);
        }

        .glass-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 10px;
        }

        .glass-save-btn,
        .glass-clear-btn {
          flex: 1 1 45%;
          padding: 10px 15px;
          border: none;
          border-radius: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .glass-save-btn {
          background: linear-gradient(135deg, #667eea, #764ba2);
          color: white;
        }

        .glass-clear-btn {
          background: linear-gradient(135deg, #ff6b6b, #ee5a52);
          color: white;
        }

        .glass-save-btn:disabled,
        .glass-clear-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .glass-message {
          margin-top: 12px;
          padding: 10px;
          border-radius: 10px;
          font-weight: 500;
        }

        .glass-message.success {
          background: #4caf50;
          color: white;
        }

        .glass-message.error {
          background: #f44336;
          color: white;
        }

        @media (max-width: 480px) {
          .glass-actions {
            flex-direction: column;
          }

          .glass-save-btn,
          .glass-clear-btn {
            flex: 1 1 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default LocalNote;